import { Component, Input, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { UnsubscribeOnDestroy } from '../../../../utility'
import { ConsumerViewService } from '../../../../injectable/consumer-view-service'
import { distinctUntilChanged } from 'rxjs/operators'

@Component({
    selector: 'app-consumer-view-toggle',
    templateUrl: 'consumer-view-toggle.html'
})
export class ConsumerViewToggleComponent extends UnsubscribeOnDestroy implements OnInit {

    @Input() label: string = ''
    @Input() value: string = ''
    @Input() checked: boolean = false
    @Input() required: boolean = false
    @Input() modifierClassname?: string

    consumerViewToggleForm: FormGroup
    fieldId = 'consumer-view-toggle-switch'
    consumerView = false

    constructor(private _consumerViewService: ConsumerViewService) {
        super()
    }

    ngOnInit(): void {
        this.consumerView = this._consumerViewService.consumerView
        this.consumerViewToggleForm = new FormGroup({})

        this._subscriptions.push(
            this.consumerViewToggleForm.valueChanges.pipe(
                distinctUntilChanged(),
              ).subscribe(formData => {
                const toggleValue = formData[this.fieldId]
                this.consumerView = toggleValue
                this._consumerViewService.toggleConsumerView(toggleValue)
            })
        )
    }
}
